module.exports = __webpack_public_path__ + "static/media/Daphne.2410068a.png";